import { APP_PATH } from "constants/path";
import { FireOutlined } from "@ant-design/icons";
import HotSale from "features/hot-sale";
import { PERMISSION } from "../constants";

const HotSaleRoutes = [
	{
		label: "Hot sale",
		path: APP_PATH.hotSale,
		key: "hot-sale",
		icon: <FireOutlined />,
		component: <HotSale />,
		permissions: [PERMISSION.HOTSALE.VIEW],
	},
];

export default HotSaleRoutes;
